import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "10",
  viewBox: "0 0 18 10"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M1.123 5.51 7.99 9.729a.62.62 0 0 0 .627.011.63.63 0 0 0 .317-.539V.805A.626.626 0 0 0 7.99.272L1.123 4.455a.62.62 0 0 0-.299.528.64.64 0 0 0 .3.527m8.947 0 6.868 4.219a.62.62 0 0 0 .627.011.63.63 0 0 0 .316-.539V.805a.626.626 0 0 0-.944-.533L10.07 4.455a.62.62 0 0 0-.299.528.64.64 0 0 0 .3.527" }, null, -1)
  ])))
}
export default { render: render }